<div class="flex flex-col w-full">
  @if (isLoading() && isInitialLoad()) {
    <div class="animate-pulse flex flex-col gap-3 p-2">
      <div class="h-4 bg-secondary-border rounded w-1/3"></div>
      <div class="h-24 bg-secondary-border rounded w-full"></div>
    </div>
  } @else if (isRelationsLoading()) {
    <div class="animate-pulse flex flex-col gap-3 p-2">
      <div class="h-4 bg-secondary-border rounded w-1/4 mb-2"></div>
      <div class="h-12 bg-secondary-border rounded w-full"></div>
      <div class="h-12 bg-secondary-border rounded w-full"></div>
      <div class="text-secondary-text text-sm italic mt-2">
        Loading relations config...
      </div>
    </div>
  } @else {
    @if (data().length === 0) {
      <div
        class="mb-4 bg-info/10 border border-info/20 text-info px-4 py-3 rounded-md flex items-center gap-2 shadow-sm"
      >
        <i class="fas fa-info-circle text-lg"></i>
        <span class="font-medium">{{ localTexts.noData }}</span>
      </div>
    }

    @if (recordIds && recordIds.length > 0) {
      <div
        class="mb-4 bg-info/10 border border-info/20 text-info px-4 py-3 rounded-md flex items-center gap-2 shadow-sm"
      >
        <i class="fas fa-info-circle text-lg"></i>
        <span class="font-medium"
          >{{ localTexts.specificRecordsInfo }} ({{ recordIds.length }})</span
        >
      </div>
    }

    <div
      class="mb-4 flex flex-col md:flex-row justify-between items-center w-full gap-4"
    >
      <div class="flex items-center gap-4">
        <div class="text-lg font-semibold">
          {{ model()?.title || model()?.name }} Data
        </div>
      </div>

      <div class="flex items-center gap-2">
        <button nz-button nzType="primary" (click)="onAddRecord()">
          <i class="fas fa-plus mr-2"></i> Add Record
        </button>
        @if (toggleFullscreen.observed || isFullscreen) {
          <button
            nz-button
            nzType="default"
            (click)="toggleFullscreen.emit()"
            class="flex items-center gap-1.5 !rounded-md text-secondary-text hover:text-primary transition-colors cursor-pointer"
            nz-tooltip
            [nzTooltipTitle]="isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'"
          >
            <i
              class="fas"
              [ngClass]="
                isFullscreen ? 'fa-compress-arrows-alt' : 'fa-expand-arrows-alt'
              "
            ></i>
            <span class="ml-1">{{
              isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'
            }}</span>
          </button>
        }
      </div>
    </div>

    <div class="mb-4 w-full overflow-hidden">
      @defer {
        <rapider-list-grid
          [config]="mainGridConfig()"
          [data]="data()"
          [enableRowPointer]="true"
          [searchText]="searchQuery()"
          [loading]="isLoading()"
          (columnActionClick)="onItemActionClick($event)"
          (rowActionClick)="onRowClick($event)"
          (itemMouseEnter)="onRowMouseEnter($event)"
          (itemMouseLeave)="onRowMouseLeave()"
          (searchSubmit)="onGridSearchSubmit($event)"
        >
        </rapider-list-grid>
      } @loading {
        <div
          class="p-4 bg-alt-bold-background flex justify-center items-center h-48"
        >
          <i class="fas fa-circle-notch fa-spin text-primary text-2xl"></i>
        </div>
      }
    </div>

    @if (!recordIds || recordIds.length === 0) {
      <div
        class="mb-6 flex justify-end w-full border-t border-secondary-border pt-3"
      >
        <nz-pagination
          [nzPageIndex]="currentPage()"
          [nzTotal]="totalItems()"
          [nzPageSize]="pageSize()"
          (nzPageIndexChange)="onPageChange($event)"
        >
        </nz-pagination>
      </div>
    }

    @if (!isFullscreen && activeDisplayRecord(); as rec) {
      <div *ngIf="rec" class="mb-4 w-full relative group">
        <div
          class="absolute top-2 right-2 z-10 opacity-0 group-hover:opacity-100 transition-opacity"
        >
          <button
            nz-button
            nzType="default"
            nzSize="small"
            (click)="onEditRecord(rec)"
          >
            <i class="fas fa-edit mr-2"></i> Edit Record
          </button>
        </div>
        <rapider-data-card
          [projectModelName]="projectModelName"
          [data]="rec"
          [diffClassMap]="diffClassMap()"
        ></rapider-data-card>
      </div>

      @if (model()?.relations; as relations) {
        <div
          class="flex flex-col gap-4 bg-alt-bold-background border border-primary-border rounded-lg p-4"
        >
          @for (rel of relations; track rel.name; let isFirst = $first) {
            @if (rec[rel.name] !== undefined && rec[rel.name] !== null) {
              @if (!isFirst) {
                <nz-divider class="my-2 border-secondary-border"></nz-divider>
              }
              <div class="flex flex-col gap-2">
                <div class="flex items-center gap-2">
                  <i class="fas fa-link text-info"></i>
                  <span class="font-bold text-primary-text">{{
                    getTargetModelTitle(
                      rel.targetModel?.title ||
                        rel.targetModel?.name ||
                        rel.name,
                      cachedModels()
                    )
                  }}</span>
                  <nz-tag class="!m-0 bg-info/10 text-info border-info/20">{{
                    rel.name
                  }}</nz-tag>
                </div>

                <div
                  class="bg-component-inner rounded-lg border border-secondary-border p-2 shadow-sm overflow-hidden"
                >
                  @if (
                    getRelationDisplayType(rel.type, rec[rel.name]) === 'grid'
                  ) {
                    @defer {
                      <rapider-list-grid
                        [config]="
                          getGridConfigForModel(
                            rel.targetModel?.name || rel.name,
                            cachedModels(),
                            normalizeDataAsArray(rec[rel.name])
                          )
                        "
                        [data]="normalizeDataAsArray(rec[rel.name])"
                      >
                      </rapider-list-grid>
                    } @loading {
                      <div class="p-4 text-center text-secondary-text">
                        Loading grid...
                      </div>
                    }
                  } @else if (
                    getRelationDisplayType(rel.type, rec[rel.name]) === 'card'
                  ) {
                    <rapider-data-card
                      [projectModelName]="
                        rel.targetModel?.name ||
                        rel.targetModel?.dataTableName ||
                        rel.targetModel ||
                        rel.name
                      "
                      [data]="rec[rel.name]"
                    >
                    </rapider-data-card>
                  } @else {
                    <rapider-json-viewer
                      [data]="rec[rel.name]"
                      [maxLineToDisplay]="10"
                      class="w-full"
                    >
                    </rapider-json-viewer>
                  }
                </div>
              </div>
            } @else {
              <div class="flex flex-col gap-2">
                <div class="flex items-center gap-2">
                  <i class="fas fa-link text-info"></i>
                  <span class="font-bold text-primary-text">{{
                    getTargetModelTitle(
                      rel.targetModel?.title ||
                        rel.targetModel?.name ||
                        rel.name,
                      cachedModels()
                    )
                  }}</span>
                  <nz-tag class="!m-0 bg-info/10 text-info border-info/20">{{
                    rel.name
                  }}</nz-tag>
                </div>
                <div
                  class="text-secondary-text text-sm italic p-2 flex items-center gap-2"
                >
                  <i class="fas fa-info-circle"></i> {{ localTexts.noData }}
                </div>
              </div>
            }
          }
        </div>
      }
    }
  }

  <nz-modal
    [nzVisible]="isFormModalVisible()"
    [nzTitle]="isEditing() ? 'Edit Record' : 'Add Record'"
    (nzOnCancel)="onFormModalCancel()"
    (nzOnOk)="onFormModalOk()"
    [nzWidth]="800"
  >
    <ng-container *nzModalContent>
      @if (activeFormSchema()) {
        <rapider-dynamic-form
          [schema]="activeFormSchema()!"
          [data]="activeFormData()"
          (formChange)="onFormChange($event)"
        ></rapider-dynamic-form>
      }
    </ng-container>
  </nz-modal>
</div>
